/* ---------------------------------------------------------------------------
   The engine's own version, recorded on every rating it produces.

   SEPARATE FROM THE PROFILE VERSION, and both are stored. The profile version
   says which standard was applied — which load factors, which vehicles, which
   era tables. This says which transcription of the method applied them. They
   move independently: a correction to the RCDG neutral axis changes this and not
   the profile, and a revision to the MLRB's load factors changes the profile and
   not this.

   BUMP IT WHENEVER AN OUTPUT COULD MOVE. Adding a family is a minor bump;
   applying a correction that changes a number is a minor bump and an entry in
   corrections.ts; a comment is neither. The rule is not the semver spec — it is
   that two ratings recorded under the same version must be reproducible from the
   same input, and that is a promise this string makes on behalf of the whole
   directory.
   --------------------------------------------------------------------------- */

export const ENGINE_VERSION = '0.3.0';

/**
 * Which families this version can actually rate.
 *
 * Checked by the API before it accepts a rating request, so an unfinished family
 * is refused with a plain answer rather than accepted and stored empty. Grows as
 * each capacity module lands.
 */
export const IMPLEMENTED = [
  { family: 'RCFS', continuity: 'simple' },
  { family: 'RCDG', continuity: 'simple' },
  { family: 'PCDG', continuity: 'simple' },
] as const;

export function isImplemented(family: string, continuity: string): boolean {
  return IMPLEMENTED.some((i) => i.family === family && i.continuity === continuity);
}
